<h3 sidenav-title>{{ data?.title ?? 'Select Communities' }}</h3>

<sidenav-content>
    <app-toggle-list [preselectedIds]="data?.selectedOrganizationIds" [data]="organizations$ | async">
        <ng-template let-organization="item">
            <app-avatar-block [initials]="organization.initials">
                <span avatarTitle>{{ organization.name }}</span>
            </app-avatar-block>
        </ng-template>

        <app-empty-state>
            <span emptyStateTitle>{{ 'No communities so far...' }}</span>
        </app-empty-state>
    </app-toggle-list>
</sidenav-content>

<sidenav-actions>
    <button *isTypeof="data?.confirmButton" mat-flat-button disableRipple color="primary" (click)="confirmSelection()">
        {{ data.confirmButton }}
    </button>
    <button *isTypeof="(data?.confirmButton || confirmLabelMapping); check: 'object'" mat-flat-button disableRipple color="primary" (click)="confirmSelection()">
        {{ listRef?.combinedValue?.length | i18nPlural: (data.confirmButton || confirmLabelMapping) }}
    </button>
</sidenav-actions>
